import React from 'react'
import { addDays, isBefore } from 'date-fns'
import { stringToDate } from 'utils/common-util'

function New({ className = '', regDttm, confirmYn }) {
  const checkNewFlag = (regDate) => {
    if (!regDate) return false
    const weekBefore = addDays(new Date(), -7)
    const regDt = stringToDate(regDate)
    return isBefore(weekBefore, regDt)
  }

  return (
    <>
      {checkNewFlag(regDttm) || confirmYn === 'N' ? (
        <span className="badge blue" style={{ paddingRight: '2px' }}>
          N
        </span>
      ) : (
        ''
      )}
    </>
  )
}

export default New
